import type { CustomEvent, ClientGroup } from "@/types/api/event"
import { DEFAULT_TZ } from "@/utils/date"

const dateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: DEFAULT_TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
})

export function toDateString (value: number | string | Date): string {
  return dateFormatter.format(new Date(value))
}

export function isBirthdateValid ({
  birthdate,
  event,
  status,
}: {
  birthdate?: number | string
  event?: CustomEvent | null
  status?: ClientGroup
}): boolean {
  if (!birthdate) return true

  const date = toDateString(birthdate)

  const defaultStatus = status || event?.statuses?.find(s => s.default)

  const minBirthdate = event?.minBirthdate || defaultStatus?.minBirthdate
  const maxBirthdate = event?.maxBirthdate || defaultStatus?.maxBirthdate

  if (minBirthdate && date < toDateString(minBirthdate)) return false
  if (maxBirthdate && date > toDateString(maxBirthdate)) return false

  return true
}

export function getBirthdateErrorParams (
  event?: CustomEvent | null,
  locale?: string,
  status?: ClientGroup,
): [string, Record<string, string>] {
  const formatter = new Intl.DateTimeFormat(locale, {
    dateStyle: "short",
    timeZone: DEFAULT_TZ,
  })

  const defaultStatus = status || event?.statuses?.find(s => s.default)

  const min = event?.minBirthdate || defaultStatus?.minBirthdate
  const max = event?.maxBirthdate || defaultStatus?.maxBirthdate

  const minBirthdate = min ? formatter.format(min) : ""
  const maxBirthdate = max ? formatter.format(max) : ""

  if (minBirthdate && !maxBirthdate)
    return ["fromDate", { minBirthdate }]

  if (!minBirthdate && maxBirthdate)
    return ["beforeDate", { maxBirthdate }]

  if (minBirthdate && maxBirthdate)
    return ["betweenDates", { minBirthdate, maxBirthdate }]

  return ["", {}]
}

export function isAdultOn (
  birthdate: number | string | Date,
  date: number | string | Date,
  adultAge = 18,
): boolean {
  const [year, month, day] = toDateString(date).split("-")

  return toDateString(birthdate) < `${Number(year) - adultAge}-${month}-${day}`
}

export function getAge (birth: number | Date): number {
  const ageMs = Date.now() - new Date(birth).getTime()
  const ageDate = new Date(ageMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
}
